<template>
  <v-container grid-list-xl class="pa-5">
    <m-card-list
      two-line
      title="Kategori"
      label-cari="Cari Kategori"
      search
      :add="allowAdd"
      :items="items"
      :headers="headers"
      refresh
      @refresh="load"
      :page="page"
      footer
      @search="
        (search) => {
          textSearch = search
          load()
        }
      "
      @change:page="
        (pg) => {
          cp = pg
          load()
        }
      "
      @add="add"
    >
      <template v-slot:items="{ props, item }">
        <tr>
          <td>{{ pVal(item, 'nama') }}</td>
          <td>{{ item.jumlah || 0 }}</td>
          <td>{{ item.masa_kerja }} Bulan</td>
          <td>{{ item.is_saldo === 1 ? 'Tidak' : 'Ya' }}</td>
          <td
            ><v-chip outlined small :color="item.is_aktif === 1 ? 'success' : 'red'">
              {{ item.is_aktif === 1 ? 'Aktif' : 'Non-Aktif' }}</v-chip
            >
          </td>
          <td>
            <div>{{ getDeepObj(item, 'updated_at') | toDT }}</div>
            <div class="grey--text caption" v-if="getDeepObj(item, 'users_updated_by.nama')">
              Oleh: {{ getDeepObj(item, 'users_updated_by.nama') }}
            </div>
          </td>
          <td>
            <m-menu left style="float: right" :items="more_menu" :object="item" />
          </td>
        </tr>
      </template>
    </m-card-list>
    <ChangeDlg ref="dlg" />
  </v-container>
</template>

<script>
import { isCan } from '@/tools'
import ChangeDlg from '../components/Form.vue'
import BlockCard from '@/components/BlockCard'

export default {
  components: {
    ChangeDlg,
    BlockCard,
  },
  data() {
    return {
      items: [],
      textSearch: null,
      page: null,
      cp: 1,
      headers: [
        { text: 'Kategori Cuti', align: 'left', value: 'nama' },
        { text: 'Saldo Cuti', align: 'left', value: 'jumlah' },
        { text: 'Minimal Masa Kerja', align: 'left', value: 'masa_kerja' },
        { text: 'Saldo Tidak Berkurang', align: 'left', value: 'saldo' },
        { text: 'Status', align: 'left', value: 'status' },
        { text: 'Terakhir diubah', align: 'left', value: 'updated_at' },
        { text: '', sortable: false },
      ],
      more_menu: [
        {
          title: 'Detail',
          click: (i, o) =>
            this.$router.push({
              name: 'kategori.detail',
              params: {
                organisasi_id: this.organisasi_id,
                kategori_id: o.cuti_kategori_id,
              },
            }),
        },
        {
          title: 'Ubah',
          click: (i, o) => this.edit(o),
          check: (i, o) => isCan('cuti-kategori.update') && Number(o.is_aktif) === 1 && Number(o.is_sistem) === 0,
        },
        {
          title: 'Hapus',
          click: (i, o) => this.hapus(o),
          check: (i, o) => isCan('cuti-kategori.destroy') && Number(o.is_sistem) === 0,
        },
        {
          title: 'Aktifkan',
          click: (i, o) => this.onDisable(o),
          check: (i, o) => Number(o.is_aktif) === 0 && Number(o.is_sistem) === 0,
        },
        {
          title: 'Non-Aktifkan',
          click: (i, o) => this.onDisable(o),
          check: (i, o) => Number(o.is_aktif) === 1 && Number(o.is_sistem) === 0,
        },
      ],
    }
  },
  computed: {
    allowAdd() {
      if (this.is_simpatika) {
        const conf = this.current_konfigurasi &&
                     this.current_konfigurasi.is_leave_management_simpatika &&
                     this.current_konfigurasi.is_leave_management_simpatika === true

        return conf ? false : this.isCan('cuti-kategori.store')
      } else {
        return this.isCan('cuti-kategori.store')
      }
    },
  },
  activated() {
    this.load()
  },
  methods: {
    load() {
      this.$store
        .dispatch('kategori/get', {
          organisasi_id: this.organisasi_id,
          params: {
            page: this.cp,
            keyword: this.textSearch,
          },
        })
        .then((res) => {
          this.page = res.data
          this.items = res.data.data
        })
        .catch((e) => e)
    },
    add() {
      this.$refs.dlg.open().then(() => {
        this.load()
      })
    },
    edit(item) {
      this.$refs.dlg.open(item).then(() => {
        this.load()
      })
    },
    hapus(item) {
      this.$confirmDanger(
        `<div class="px-5 mx-1 mt-2 py-2 mb-4 pa-1 row red lighten-5 rounded red--text">

            <i class="v-icon v-alert__icon mdi mdi-information red--text"></i>

            <div class="col py-0 body-2">
            Data Kategori ${item.nama} yang telah di masukkan ke data user juga akan dihapus oleh sistem
          </div>
        </div>


        Apakah Anda yakin akan menghapus data ini ?<br>
        <div class="mt-2 title grow text-center">
         ${item.nama}<br>
        </div>

      `
      )
        .then(() =>
          this.$store.dispatch('kategori/drop', {
            organisasi_id: this.organisasi_id,
            id: item.cuti_kategori_id,
          })
        )
        .then(() => {
          this.$info('Data berhasil dihapus')
        })
        .then(() => this.load())
        .catch((e) => e)
    },
    onDisable(item) {
      const labelStatus = item.is_aktif === 1 ? 'Aktif menjadi <b>tidak aktif</b>' : 'Tidak aktif menjadi <b>Aktif</b>'
      const confirmHmtl = {
        konfirmasi: `
        <div class="v-alert v-sheet theme--light v-alert--dense v-alert--text red--text">
            <div class="v-alert__wrapper">
                <i aria-hidden="true" class="v-icon notranslate v-alert__icon mdi mdi-information theme--light red--text"></i>
                <div class="v-alert__content">
                    Pastikan Anda benar benar mengerti apa yang Anda lakukan
                </div>
            </div>
        </div>
        <div>
            Apakah Anda akan Mengubah status kategori cuti berikut menjadi <b>${
              item.is_aktif === 1 ? 'Non-aktif' : 'Aktif'
            } ?</b>
        </div>
        ${item.is_aktif === 1 ? '<div>Proses non aktif akan me-reset status verifikasi wajar(enrollment)</div>' : ''}
        <div class="text-center headline my-2">
            <b>${item.nama}</b>
        </div>
        `,
        deskripsi: `
          <div class="v-alert v-sheet theme--light v-alert--dense v-alert--text red--text">
            <div class="v-alert__wrapper">
                <i aria-hidden="true" class="v-icon notranslate v-alert__icon mdi mdi-information theme--light red--text"></i>
                <div class="v-alert__content">
                    Anda akan melakukan perubahan status Pengguna dari ${labelStatus}
                </div>
            </div>
        </div>
        <div class="my-5">
            Tulis alasan Anda Mengubah status <b>${item.nama}</b> menjadi ${
          item.is_aktif === 1 ? 'Tidak Aktif' : 'Aktif'
        } :
        </div>
        `,
      }

      this.$confirm(confirmHmtl.konfirmasi, {}, 'Konfirmasi').then(() => {
        this.$store
          .dispatch('kategori/updateStatus', {
            organisasi_id: this.organisasi_id,
            obj: {
              cuti_kategori_id: item.cuti_kategori_id,
              is_aktif: item.is_aktif === 1 ? 0 : 1,
            },
          })
          .then(() => {
            this.$success(item.is_aktif === 0 ? 'Kategori berhasil di Aktifkan' : 'Kategori berhasil di Non Aktifkan')
            this.load()
          })
      })
    },
  },
}
</script>
